import { Component, AfterViewInit, OnDestroy, Input, ViewChild, ElementRef, HostBinding } from '@angular/core';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements AfterViewInit, OnDestroy {
  @Input() embedded: boolean = false;
  @ViewChild('tbEl') tbEl: ElementRef | undefined;

  private resizeObserver: any = null;

  @HostBinding('class.tb-embedded') get isEmbedded(): boolean { return this.embedded; }

  ngAfterViewInit(): void {
    if (this.tbEl && !this.embedded) {
      this.updateHeaderHeight();
      const RO = (window as any).ResizeObserver;
      if (RO) {
        this.resizeObserver = new RO(() => this.updateHeaderHeight());
        this.resizeObserver.observe(this.tbEl.nativeElement);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  private updateHeaderHeight(): void {
    if (this.tbEl) {
      const height = this.tbEl.nativeElement.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }
  }
}
